<template>
  <li class="job-offer__card"  v-reveal>
    <a :href="content.link" class="job-offer" target="_blank">
      <div class="job-offer__image-container">
        <img v-if="content.image" :src="content.image" alt="" class="job-offer__image">
        <p v-if="!content.image">{{ $beet.companies[content.company].name }}</p>
      </div>
      <div class="job-offer__content">
        <h3 class="job-offer__title">{{ content.title }}</h3>
        <p class="job-offer__type">{{ $beet.jobTypes[content.type].name }}</p>
        <div class="job-offer__bottom">
          <p class="job-offer__location">{{ $beet.locations[content.location].name }}</p>
          <ArrowButton tag="div" dark class="job-offer__button"/>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
import {ArrowButton} from '@/components/small'
import {HasContentMixin} from '@/mixins'

export default {
  name: 'JobOfferCard',
  mixins: [HasContentMixin],
  components: {ArrowButton}
}
</script>